<template>
    <v-layout class="mt-3">
        <v-flex xs12 class="pl-0">
            <v-card class="mx-aut" flat>
                <confirmation-header-text text="Marriage visa details" class="ml-0"
                                          icon="mdi-human-male-female"></confirmation-header-text>

                <v-card-text class="pb-0">
                    <v-layout row >
                        <v-flex xs12>
                            <v-select
                                :items="relations"
                                :rules="[rules.required]"
                                label="Gender *"
                                outlined
                                v-model="visa.extra.extra_traveller.gender"
                            ></v-select>
                        </v-flex>

                        <v-flex class="pr-2" sm6 xs12>
                            <v-text-field
                                label="Full name of Husband/Wife *"
                                outlined
                                type="text"
                                v-model="visa.extra.extra_traveller.full_name"
                            ></v-text-field>
                        </v-flex>
                        <v-flex sm6 xs12>
                            <address-auto-complete
                                label="Address in Nepal"
                                country-code="np"
                                v-model="visa.extra.extra_traveller.full_address"
                            ></address-auto-complete>
                        </v-flex>
                        <v-flex class="pr-2" sm6 xs12>
                            <v-text-field
                                :label="getDynamicLabel('Citizenship number ')"
                                outlined
                                type="text"
                                v-model="visa.extra.extra_traveller.document_number"
                            ></v-text-field>
                        </v-flex>
                        <v-flex class="pl-2" sm6 xs12>
                            <date-picker-nepali
                                :label="getDynamicLabel('Date of birth (BS)')"
                                :rules="[rules.required]"
                                v-model="visa.extra.extra_traveller.dob"
                                :min-year="dob.min_year_np"
                                :max-year="dob.max_year_np"
                            ></date-picker-nepali>
                        </v-flex>
                        <v-flex class="pr-3 pl-3" sm6 xs12>
                            <new-date-picker
                                :label="getDynamicLabel('Date of marriage')"
                                :rules="[rules.required]"
                                :min-year="dateOfMarriage.min_year"
                                :max-year="dateOfMarriage.max_year"
                                v-model="visa.extra.application_data.date_of_marriage"
                            />
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-text-field
                                label="Place of marriage"
                                outlined
                                type="text"
                                v-model="visa.extra.application_data.place_of_marriage"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    // import DatePicker from "../../DatePicker";
    import FileInput from "../../FileInput";
    import NewDatePicker from "../../NewDatePicker";
    import DatePickerNepali from "../../DatePickerNepali";

    export default {
        data: () => ({

            rules: {
                required: value => !!value || "Required."
            },
            options: [
                {
                    text: "Nepal",
                    value: "Nepal"
                },
                {
                    text: "Abroad",
                    value: "Abroad"
                }
            ],
            relations: ['Male', 'Female']
        }),
        components: {
            DatePickerNepali,
            NewDatePicker,
            FileInput, ConfirmationHeaderText,
            "address-auto-complete": AddressAutoComplete
        },
        computed: {
            visa() {
                return this.$store.state.VisaRequestSingle.visaRequest;
            },
            dob() {
                let max_year = new Date().toISOString().substr(0, 4);
                max_year = parseInt(max_year);
                const min_year = max_year - 120;
                const max_year_np = max_year + 56;
                const min_year_np = max_year_np - 120;
                return {
                    min_year,
                    max_year,
                    min_year_np,
                    max_year_np
                }
            },
            dateOfMarriage() {
                let max_year = new Date().toISOString().substr(0, 4);
                max_year = parseInt(max_year);
                const min_year = max_year - 120;
                return {
                    min_year,
                    max_year,
                }
            },
        },
        methods: {
            addressChanged(e) {
                this.visa.extra.application_data.address = e;
            },
            getDynamicLabel(text) {
                if (this.visa.extra.extra_traveller.full_name) {
                    return text + ' of ' + this.visa.extra.extra_traveller.full_name + ' *'
                } else if (this.visa.extra.extra_traveller.married_to) {
                    return text + ' of ' + this.visa.extra.extra_traveller.married_to + ' *'
                } else {
                    return text + ' of Husband/Wife *'
                }
            },
        }
    };
</script>
